export default __webpack_public_path__ + "static/media/US.6aaaff76.svg";